export const TAREAS_TYPES = {
  SENDFORM: "SENDFORM",
  SENDFORMWITHCHANGES: "SENDFORMWITHCHANGES",
  DELETEROW: "DELETEROW",
  DATAOFLOCALSTORAGE: "DATAOFLOCALSTORAGE",
};
